import { create } from 'zustand';

const useChainStore = create((set) => ({
  chainList: [],
  getChainList: async (queryParametersObject) => {
    const { checkIn, checkOut, latitude, longitude, rooms, adults } = queryParametersObject;
    const params = `check_in=${checkIn}&check_out=${checkOut}&latitude=${latitude}&longitude=${longitude}&rooms=${rooms}&adults=${adults}`;
    const req = await fetch(`${process.env.API_URL}/hotel/search/list-chain/?${params}`, { credentials: 'include' });
    const res = await req.json();
    set({ chainList: res });
  },
  removeAllBears: () => set({ bears: 0 }),
}));

export default useChainStore;
